import { CbBankFieldTypes } from './fields';

export const cbBankSteps: Record<keyof CbBankFieldTypes, keyof CbBankFieldTypes> = {
  financingNeedPage: 'financingNeedPage',
  companyDataPage: 'companyDataPage',
  offerPage: 'offerPage',
  personalDataPage: 'personalDataPage',
} as const;
